import React, { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import ContactView from "../views/ContactView";
import i18n from "../../../i18n";
import { route } from "../../../routes";
import {
  FormUtility,
  withCourseContactApi,
  withAuthentication,
} from "cw-styleguide-react";
import { LANGUAGE_CY, LANGUAGE_EN } from "../../../constants";
import withAuditApi from "../../../apis/withAuditApi";

class ContactsController extends Component {
  /**
   * constructor.
   * @param props
   */
  constructor(props) {
    super(props);

    // State.
    this.state = {
      inputLanguage: LANGUAGE_EN,
      values: this.getInitialValues(),
      formErrors: {},
      modals: {
        bulkDelete: false,
        bulkArchive: false,
        bulkRollback: false,
        delete: false,
        archive: false,
        rollback: false,
      },
      manualContactName: false,
      reloadKey: Math.random(),
      loaded: false,
      messages: new Set(),
      redirect: null,
      selected: new Set(),
      isLoadingContact: false,
      query: ''
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.clearMessages = this.clearMessages.bind(this);
    this.clearSelected = this.clearSelected.bind(this);
    this.clearRedirect = this.clearRedirect.bind(this);
    this.setReloadKey = this.setReloadKey.bind(this);
    this.loadAudit = this.loadAudit.bind(this);
    this.clearAudit = this.clearAudit.bind(this);
    this.loadContact = this.loadContact.bind(this);
    this.saveContact = this.saveContact.bind(this);
    this.deleteContact = this.deleteContact.bind(this);
    this.archiveContact = this.archiveContact.bind(this);
    this.rollbackContact = this.rollbackContact.bind(this);
    this.handleBulkCheckbox = this.handleBulkCheckbox.bind(this);
    this.handleManualContactName = this.handleManualContactName.bind(this);
    this.hasManualContactName = this.hasManualContactName.bind(this);
    this.handleContactNameSelect = this.handleContactNameSelect.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.clearContact = this.clearContact.bind(this);
    this.handleSetInputLanguage = this.handleSetInputLanguage.bind(this);
    this.handleErrorClick = this.handleErrorClick.bind(this);
    this.setQuery = this.setQuery.bind(this);
  }

  /**
   * getInitialValues
   */
  getInitialValues() {
    return {
      id: "",
      atlasAccountId: this.props.authentication.hasRole("Courses_Provider")
        ? this.props.authentication.getClaim("atlasAccountId")
        : "",
      atlasAccountLabel: "",
      contactName_en: "",
      contactName_cy: "",
      telephoneNumber_en: "",
      telephoneNumber_cy: "",
      mobileNumber: "",
      email_en: "",
      email_cy: "",
      status: "",
      confirmationDate: "",
      confirmedAccurate: new Set(),
    };
  }

  /**
   * clearContact
   */
  clearContact() {
    this.setState({
      inputLanguage: LANGUAGE_EN,
      values: this.getInitialValues(),
      manualContactName: false,
    });
  }

  /**
   * clearSelected
   */
  clearRedirect() {
    this.setState({
      redirect: null,
    });
  }

  /**
   * clearSelected
   */
  clearSelected() {
    this.setState({
      selected: new Set(),
    });
  }

  /**
   * clearMessages
   */
  clearMessages() {
    this.setState({
      messages: new Set(),
      formErrors: {},
    });
  }

  /**
   * Set a new reload key forcing a page refresh.
   */
  setReloadKey() {
    this.setState({
      reloadKey: Math.random(),
    });
  }

  /**
   * toggleModal
   * @param id
   */
  toggleModal(ids, visiblity) {
    const modals = { ...this.state.modals };

    // loop through the ids.
    ids.forEach((id) => {
      modals[id] = visiblity;
    });

    this.setState({
      modals: modals,
    });
  }

  /**
   * Handle the bulk selection of contacts checkboxes.
   * @param event
   */
  handleBulkCheckbox(event) {
    const selected = this.state.selected;
    if (selected.has(event.target.value)) {
      selected.delete(event.target.value);
    } else {
      selected.add(event.target.value);
    }
    this.setState({
      selected: selected,
    });
  }

  /**
   * Handle clicking on the enter manual address link.
   * @param event
   */
  handleManualContactName(event) {
    event.preventDefault();
    this.setState({
      manualContactName: true,
    });
  }

  /**
   * hasManualContactName
   * @returns {*|string}
   */
  hasManualContactName(language) {
    const values = { ...this.state.values };
    return values["contactName_" + language];
  }

  handleContactNameSelect(event, language, assets) {
    event.preventDefault();
    const values = { ...this.state.values };

    values["contactName_en"] =
      assets.contactTypeLookup[LANGUAGE_EN][event.target.value];
    values["contactName_cy"] =
      assets.contactTypeLookup[LANGUAGE_CY][event.target.value];
    this.setState({
      values: values,
    });
  }

  /**
   * Handle field onChange events and save to the state.
   * @param event
   */
  handleChange(event) {
    const values = { ...this.state.values };

    this.setState({
      values: FormUtility.setFormValues(event, values),
    });
  }

  /**
   * loadAudit
   * @param id
   */
  loadAudit(id) {
    this.props.auditApiGetAudit(
      id,
      "contact",
      i18n.language,
      (response) => {
        this.setState({
          audit: response.data,
        });
      },
      (error) => {
        this.setState({
          audit: false,
        });
      }
    );
  }

  clearAudit() {
    this.setState({
      audit: false,
    });
  }

  /**
   * Load a contact for a given ID.
   * @param id
   */
  loadContact(id) {
    this.setState({
      loaded: false,
      isLoadingContact: true,
    });
    console.log("geeting lang", i18n.language);
    this.props.courseContactApiGetContacts(
      [id],
      {},
      i18n.language,
      (response) => {
        switch (response.status) {
          case 204:
            // Checking for a 204 response for #12360
            // https://dev.azure.com/ccdg/CWO%20-%20Courses/_workitems/edit/12360
            this.setState({
              loaded: false,
              isLoadingContact: false,
            });
            break;

          case 200:
            this.setState({
              values: {
                id: response.data[0].id,
                atlasAccountId: response.data[0].atlasAccount.atlasAccountId,
                atlasAccountLabel:
                  response.data[0].atlasAccount["cw_courseprovidername"],
                contactName_en: response.data[0].contactName.en,
                contactName_cy: response.data[0].contactName.cy,
                telephoneNumber_en: response.data[0].telephoneNumber.en,
                telephoneNumber_cy: response.data[0].telephoneNumber.cy,
                email_en: response.data[0].email.en,
                email_cy: response.data[0].email.cy,
                mobileNumber: response.data[0].mobileNumber,
                status: response.data[0].status,
                confirmationDate: response.data[0].confirmationDate,
                confirmedAccurate: new Set(),
              },
              loaded: true,
              isLoadingContact: false,
            });
            break;
        }
      },
      (error) => {
        console.log("ERROR");
        let errors = FormUtility.processServerErrors(error, i18n);
        this.setState({
          formErrors: errors.formErrors,
          messages: errors.messages,
          loaded: false,
          isLoadingContact: false,
        });
      }
    );
  }

  /**
   * Create a contact.
   * @param status
   */
  saveContact(status) {
    // Start the spinner going, will be removed on success or failure of the submit.
    this.setState({
      submitting: true,
    });

    // Build the Post JSON.
    let payload = {
      contactName: {
        cy: this.state.values.contactName_cy,
        en: this.state.values.contactName_en,
      },
      telephoneNumber: {
        cy: this.state.values.telephoneNumber_cy,
        en: this.state.values.telephoneNumber_en,
      },
      mobileNumber: this.state.values.mobileNumber,
      atlasAccount: {
        atlasAccountId: this.state.values.atlasAccountId,
      },
      email: {
        cy: this.state.values.email_cy,
        en: this.state.values.email_en,
      },
      status: status,
    };

    // If we have and ID then add it.
    if (this.state.values.id) {
      payload.id = this.state.values.id;
    }

    this.props.courseContactApiPostContacts(
      payload,
      this.state.values.confirmedAccurate.has("1"),
      i18n.language,
      (response) => {
        // Save the current state of messages.
        let messages = this.state.messages;

        messages.add({
          type: "positive",
          message: i18n.t(
            "local:view.contacts.status." + response.data.status + ".success"
          ),
        });
        this.setState({
          formErrors: [],
          redirect: route("contactsManage") + this.state.query,
        });

        // Add the messages.
        this.setState({ messages: messages });
      },
      (error) => {
        let errors = FormUtility.processServerErrors(error, i18n);
        this.setState({
          formErrors: errors.formErrors,
          messages: errors.messages,
        });
      }
    );
  }

  /**
   * deleteContact
   * @param ids
   */
  deleteContact(ids, redirect = null) {
    this.props.courseContactApiDeleteContact(
      ids,
      i18n.language,
      (response) => {
        let messages = new Set();

        if (response.data.contactIds.length === 1) {
          messages.add({
            type: "positive",
            message: i18n.t(
              "local:view.contacts.manage.messages.delete.singular",
              { count: response.data.contactIds.length }
            ),
          });
        } else {
          messages.add({
            type: "positive",
            message: i18n.t(
              "local:view.contacts.manage.messages.delete.plural",
              { count: response.data.contactIds.length }
            ),
          });
        }

        this.setState({
          formErrors: [],
          messages: messages,
          selected: new Set(),
          redirect: redirect,
          reloadKey: Math.random(),
        });

        this.toggleModal(["delete", "bulkDelete"], false);
      },
      (error) => {
        this.toggleModal(["delete", "bulkDelete"], false);
        this.setState(FormUtility.processServerErrors(error, i18n));
      }
    );
  }

  /**
   * archiveContact
   * @param ids
   */
  archiveContact(ids, redirect = null) {
    this.props.courseContactApiArchiveContact(
      ids,
      i18n.language,
      (response) => {
        let messages = new Set();

        // Display a plural or singular message on successful deletion.
        if (response.data.contactIds.length === 1) {
          messages.add({
            type: "positive",
            message: i18n.t(
              "local:view.contacts.manage.messages.archive.singular",
              { count: response.data.contactIds.length }
            ),
          });
        } else {
          messages.add({
            type: "positive",
            message: i18n.t(
              "local:view.contacts.manage.messages.archive.plural",
              { count: response.data.contactIds.length }
            ),
          });
        }

        this.setState({
          formErrors: [],
          messages: messages,
          selected: new Set(),
          redirect: redirect,
          reloadKey: Math.random(),
        });
        this.toggleModal(["archive", "bulkArchive"], false);
      },
      (error) => {
        this.toggleModal(["archive", "bulkArchive"], false);
        this.setState(FormUtility.processServerErrors(error, i18n));
      }
    );
  }

  /**
   * rollbackContact
   * @param ids
   */
  rollbackContact(ids, redirect = null) {
    this.props.courseContactApiDeleteDraft(
      ids,
      i18n.language,
      (response) => {
        let messages = new Set();

        // Display a plural or singular message on successful deletion.
        if (response.data.contactIds.length === 1) {
          messages.add({
            type: "positive",
            message: i18n.t(
              "local:view.contacts.manage.messages.rollback.singular",
              { count: response.data.contactIds.length }
            ),
          });
        } else {
          messages.add({
            type: "positive",
            message: i18n.t(
              "local:view.contacts.manage.messages.rollback.plural",
              { count: response.data.contactIds.length }
            ),
          });
        }

        this.setState({
          formErrors: [],
          messages: messages,
          selected: new Set(),
          redirect: redirect,
          reloadKey: Math.random(),
        });
        this.toggleModal(["rollback", "bulkRollback"], false);
      },
      (error) => {
        this.toggleModal(["rollback", "bulkRollback"], false);
        this.setState(FormUtility.processServerErrors(error, i18n));
      }
    );
  }

  /**
   * setQuery
   * @param value
   */
  setQuery(value) {
    this.setState({
      query: value,
    });
  }

  /**
   * Keep track of the current input language.
   * @param event
   */
  handleSetInputLanguage(e) {
    e.preventDefault();
    this.setState({
      inputLanguage: e.target.value,
    });
  }

  /**
   * Perform a customised action if someone clicks on an error in the summary. Used to change the language to welsh.
   * @param event
   * @param field
   */
  handleErrorClick(event, field) {
    // We dont prevent the event default as we still want to go to the clicked route.
    this.setState({
      inputLanguage: field.includes("_cy") ? LANGUAGE_CY : LANGUAGE_EN,
    });
  }

  render() {
    return (
      <Fragment>
        <ContactView
          {...this.state}
          toggleModal={this.toggleModal}
          clearMessages={this.clearMessages}
          clearSelected={this.clearSelected}
          clearRedirect={this.clearRedirect}
          loadAudit={this.loadAudit}
          clearAudit={this.clearAudit}
          saveContact={this.saveContact}
          loadContact={this.loadContact}
          deleteContact={this.deleteContact}
          archiveContact={this.archiveContact}
          rollbackContact={this.rollbackContact}
          handleBulkCheckbox={this.handleBulkCheckbox}
          handleManualContactName={this.handleManualContactName}
          hasManualContactName={this.hasManualContactName}
          handleContactNameSelect={this.handleContactNameSelect}
          handleChange={this.handleChange}
          clearContact={this.clearContact}
          handleSetInputLanguage={this.handleSetInputLanguage}
          handleErrorClick={this.handleErrorClick}
          setReloadKey={this.setReloadKey}
          setQuery={this.setQuery}
        />
      </Fragment>
    );
  }
}

export default withAuthentication(
  withAuditApi(process.env)(
    withCourseContactApi(process.env)(
      withTranslation("local")(ContactsController)
    )
  )
);
